// see https://stackoverflow.com/questions/710586/json-stringify-array-bizarreness-with-prototype-js
export function fixPrototypeJsToJSONBug(): void {
  // Prototype.js 1.6.x toJSON has a bug
  const arrayProto = Array.prototype as any
  if (arrayProto.toJSON) {
    const stringify = JSON.stringify
    JSON.stringify = function (value: any, ...rest: any[]): string {
      const arrayToJSON = arrayProto.toJSON
      delete arrayProto.toJSON
      const result = stringify(value, ...rest)
      arrayProto.toJSON = arrayToJSON
      return result
    }
  }
}
